import { ButtonHTMLAttributes, forwardRef } from 'react';

import styled from 'styled-components';

import { BaseIcon } from '@components/icons/base';
import { Horizontal } from '@components/stack';
import { Text } from '@components/text';
import { theme } from '@styles/theme';
import { pxToRem } from '@utils/converters';
import { transitionStandard } from '@utils/transitions';

export type BadgeButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  icon: typeof BaseIcon;
  text: string | number;
};

export const BadgeButton = forwardRef<HTMLButtonElement, BadgeButtonProps>(
  ({ icon: Icon, text, ...props }, ref) => {
    return (
      <BadgeButtonContainer ref={ref} {...props}>
        <Horizontal space={1} align="center">
          <Icon color="buttonIconPositive" size={16} />
          <TextContainer>
            <Text font="semibold14" text={text} color="textSecondary" />
          </TextContainer>
        </Horizontal>
      </BadgeButtonContainer>
    );
  },
);

const BadgeButtonContainer = styled.button({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  gap: pxToRem(2),
  padding: pxToRem(4),
  borderRadius: pxToRem(2),
  cursor: 'pointer',
  backgroundColor: theme.color.uiTrans5,
  transition: transitionStandard('all'),
  ':hover': {
    backgroundColor: theme.color.uiTrans10,
  },
});

const TextContainer = styled.div({
  minWidth: pxToRem(16),
  height: pxToRem(16),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '> span': {
    lineHeight: 1,
  },
});
